interface V3IconFullscreenProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconFullscreen = ({ stroke = "#6E7687", ...rest }: V3IconFullscreenProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 4h4v4M14 10l6-6M8 20H4v-4M4 20l6-6M16 20h4v-4M14 14l6 6M8 4H4v4M4 4l6 6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
